import { JobRating } from "../../../../common/JobOrder";
import formData from "./formData";

const {
  formField: { fillByDate, onsigner, rating, port },
} = formData;

const initialValues = {
  [fillByDate.name]: "",
  [onsigner.name]: undefined,
  [rating.name]: JobRating._PM,
  [port.name]: "",
};

export default initialValues;
